import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { EntityLookupItemDto } from '../pma-entity-types';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PmaEntityLookupHttpService {

  constructor(
    private readonly urlBuilder: UrlBuilderService,
    private readonly http: HttpClient) { }

  lookup(entityTypeName: string, query: string) : Observable<EntityLookupItemDto[]> {
    const url = this.urlBuilder.getUrl(`entity-lookup/${entityTypeName}?search=${query}`);
    return this.http.get<EntityLookupItemDto[]>(url);
  }

  byKey(entitykey: any) {
    const url = this.urlBuilder.getUrl(`entity-lookup/bykey`);
    return this.http.post<EntityLookupItemDto>(url, entitykey);
  }

  entityForEntity(entityKey: any, entityName: string, query: string = '') {
    const request: EntityForEntityRequest = {EntityTypeName: entityName, EntityKey: entityKey};
    const url = this.urlBuilder.getUrl(`entity-lookup/entityforentity?search=${query}`);
    return this.http.post<EntityLookupItemDto[]>(url, request);
  }

  entityForEntities(entityKey: any[], entityName: string, forEntitiesTypeName: string) {
    const request: EntityForEntitiesRequest = {EntityTypeName: entityName, ForEntitiesTypeName: forEntitiesTypeName, EntityKeys: entityKey}
    const url = this.urlBuilder.getUrl(`entity-lookup/entityforentities`);
    return this.http.post<EntityLookupItemDto[]>(url, request);
  }
}

export class EntityForEntityRequest {
  EntityTypeName: string;
  EntityKey : any;
}

export class EntityForEntitiesRequest {
  EntityTypeName: string;
  ForEntitiesTypeName: string;
  EntityKeys : any[];
}
